import { createFileRoute } from '@tanstack/react-router'
import { Drilldown } from 'pages/drilldown/Drilldown'
import {
  SEARCH_PARAM_EXPLORATION_ID,
  SEARCH_PARAM_FOCUS_PANEL,
  SEARCH_PARAM_PRESENTATION_MODE,
} from 'routes/explorer/-searchParams'
import { z } from 'zod'

const drilldownSearchParams = z.object({
  [SEARCH_PARAM_PRESENTATION_MODE]: z.string().optional(),
  [SEARCH_PARAM_EXPLORATION_ID]: z.string().optional(),
  [SEARCH_PARAM_FOCUS_PANEL]: z.string().optional(),
})

export const Route = createFileRoute('/explorer/')({
  component: Drilldown,
  staticData: {
    title: 'Explorer',
  },
  validateSearch: drilldownSearchParams,
})
